import _ from 'lodash'

export const PatientEligibilityVerificationStatus = {
  CRITERIA_MET: { text: 'Verified: Included', value: 'CRITERIA_MET' },
  CRITERIA_NOT_MET: { text: 'Verified: Excluded', value: 'CRITERIA_NOT_MET' },
  IN_REVIEW: { text: 'In Review', value: 'IN_REVIEW' },
  NONE: { text: 'Select', value: 'NONE' },
  NOT_APPLICABLE: { text: 'Not Applicable', value: 'NOT_APPLICABLE' },
  RESET: { text: '', value: 'RESET' }
}

export const TrialIdentificationEligibilityStatus = {
  POSITIVE_IDENTIFICATION: { text: '', value: 'POSITIVE_IDENTIFICATION' },
  NEGATIVE_IDENTIFICATION: { text: 'Negative Identification', value: 'NEGATIVE_IDENTIFICATION' },
  NONE: { text: 'None', value: 'NONE' }
}

export const TrialIdentificationStatusValue = {
  IN_REVIEW: { text: 'In Review', value: 'IN_REVIEW' },
  CONTINGENT: { text: 'Contingent', value: 'CONTINGENT' },
  FOLLOWING: { text: 'Following', value: 'FOLLOWING' },
  AWAITING_REVIEW: { text: 'Awaiting Review', value: 'AWAITING_REVIEW' },
  MATCHED: { text: 'Matched', value: 'MATCHED' },
  NOT_ELIGIBLE: { text: 'Not Eligible', value: 'NOT_ELIGIBLE' },
  NOT_CONSENTED: { text: 'Not Consented', value: 'NOT_CONSENTED' },
  ENROLLED: { text: 'Enrolled', value: 'ENROLLED' }
}

export const TrialStatus = {
  NOT_STARTED: { text: 'Not Started', value: 'NOT_STARTED', icon: 'trial-status-suspended-icon' },
  RECRUITING: { text: 'Recruiting', value: 'RECRUITING', icon: 'trial-status-open-icon' },
  SUSPENDED: { text: 'Suspended', value: 'SUSPENDED', icon: 'trial-status-suspended-icon' },
  COMPLETED: { text: 'Completed', value: 'COMPLETED', icon: 'trial-status-closed-icon' },
  TERMINATED: { text: 'Terminated', value: 'TERMINATED', icon: 'trial-status-closed-icon' },
  FEASIBILITY: {
    text: 'Real Time Feasibility',
    value: 'FEASIBILITY',
    icon: 'trial-status-feasibility-icon'
  },
  MATCHING: { text: 'Matching', value: 'MATCHING', icon: 'trial-status-matching-icon' }
}

export function getStatusFromNotesOrVerification(notes, patientEligibilityVerification) {
  const latestStatusNote = _.maxBy(
    _.filter(notes, it => it.identificationStatus),
    it => it.createTimestamp
  )

  if (
    patientEligibilityVerification &&
    patientEligibilityVerification.status === PatientEligibilityVerificationStatus.RESET.value
  ) {
    return patientEligibilityVerification.status
  } else if (latestStatusNote) {
    return latestStatusNote.identificationStatus
  } else {
    return null
  }
}
